webpackJsonp([102223549061685],{

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	;
	var icon2 = "https://winpeforum.com/assets/elements/DaivikRaval.png";
	var icon3 = "https://winpeforum.com/assets/elements/PratitiDasgupta.png";
	var icon4 = "https://winpeforum.com/assets/elements/AnkitaBalotia.png";
	
	var duration = 400;
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	    _this.Speaker2 = [{
	      imgUrl: icon3,
	      desc: "<div>\nPratiti is an infrastructure and private markets finance professional with experience spanning project finance, capital raising, and investment analysis across renewables, digital infrastructure, and private credit in India, Southeast Asia, and Europe. A Winpe Ambassador , she has been a part of the community since 2021 and is highly passionate about spearheading the cause of diversity in alternative investments.\n\n\n\n\n\n\n \n          </div>",
	      name: "Pratiti Dasgupta ",
	      post: "<div> \n\n\n\n\n\n\n          </div>"
	    }];
	    _this.Speaker1 = [{
	      imgUrl: icon4,
	      desc: "<div>\nAnkita Balotia is a Principal at Fireside Ventures, where she partners with founders building the next generation of consumer brands and platforms in India. Her select boards include Sweet Karam Coffee, Frubon, Ace Blend, Troovy, and Happi Planet.\n<br/><br/>\nHer work at Fireside focuses on helping companies move from strong product ideas to enduring consumer businesses. She works closely with founders on product strategy, customer insight, and scaling operating capabilities as companies transition from early traction to sustained growth. Ankita is particularly interested in how technology and data are reshaping consumer brands enabling companies to build deeper relationships with customers and evolve from product-led businesses into long-term consumer platforms.\n<br/><Br/>\nBefore joining Fireside, Ankita was part of Venture Highway (now General Catalyst India), where she worked with early-stage startups across consumer and technology sectors.\n<Br/><Br/>\nAnkita spent over five years in management consulting with Bain & Company and Strategy, advising companies across consumer technology healthcare, and real estate on growth strategy and digital transformation.\n<br/><Br/>\nAnkita holds a degree in Computer Science from IIT Delhi and an MBA from IIM Ahmedabad. \n\n\n\n\n \n          </div>",
	      name: "Ankita Balotia ",
	      post: "<div>Principal <br/>\nFireside Ventures\n\n\n\n\n\n\n          </div>"
	    }, {
	      imgUrl: icon2,
	      desc: "<div>\nDaivik brings a well-rounded blend of investing, entrepreneurial, and capital markets experience, with over ten years across growth equity, investment banking, and business building. He has led and supported multiple equity transactions across diverse sectors, with a strong focus on India\u2019s emerging new-age economy.\n<br/><br/>\nPrior to his current role, he was part of the growth equity investment team at Mirae Asset, and has also worked with Morgan Stanley and J.P. Morgan across capital markets and investment banking.\n<br/><br/>\nIn addition to his investing experience, Daivik has hands-on operating exposure, having launched an online consumer business in the Middle East. He has successfully completed multiple growth equity investments in some of India\u2019s leading new-tech companies (Swiggy, Bigbasket, Cashfree, Fibe etc.)\n\n          </div>",
	      name: "Daivik Raval",
	      post: "<div>Vice President, Growth Equity <br/>  Trifecta Capital \n\n          </div>"
	    }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Winpe Ignite: AI for Investors",
	        image: "https://winpeforum.com/api/src/templates/emailers/assets/newsletter2022.png",
	        description: "On 16th May 2026, Winpe hosted an Ignite session on how AI is reshaping investing workflows across sourcing, research, and diligence. Featuring Ankita Balotia and Daivik Raval, moderated by Pratiti Dasgupta, the session explored practical applications of AI in day-to-day investing workflows. Click here to view the recorded session.\u201D\r\n",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                " Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "m_heading" },
	              "Winpe Ignite: AI for Investors ",
	              _react2.default.createElement("br", null),
	              " Practical AI Tools for Deal Sourcing, Research & Diligence "
	            ),
	            _react2.default.createElement("div", { className: "r_btm" }),
	            _react2.default.createElement(
	              "div",
	              { className: "date_heading" },
	              _react2.default.createElement(
	                "div",
	                { className: "date_heading" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "May 16, 2026"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  " ",
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "Online"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { textAlign: 'justify' } },
	              "On 16th May 2026, Winpe hosted an Ignite session on how AI is reshaping investing workflows across sourcing, research, and diligence. Featuring ",
	              _react2.default.createElement(
	                "a",
	                { style: { color: 'blue' }, href: "https://www.linkedin.com/in/ankita-balotia1792/" },
	                "Ankita Balotia"
	              ),
	              " and ",
	              _react2.default.createElement(
	                "a",
	                { style: { color: 'blue' }, href: "https://www.linkedin.com/in/daivikraval/" },
	                "Daivik Raval"
	              ),
	              ", moderated by ",
	              _react2.default.createElement(
	                "a",
	                { style: { color: 'blue' }, href: "https://www.linkedin.com/in/pratiti-dasgupta-bb92671b1/" },
	                "Pratiti Dasgupta"
	              ),
	              ", the session explored practical applications of AI in day-to-day investing workflows. Click ",
	              _react2.default.createElement(
	                "a",
	                { style: { color: 'blue' }, href: "https://youtu.be/4vE_Yc7iAlQ" },
	                "here"
	              ),
	              " to view the recorded session.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "A live poll kicked off the session, with the top challenge in the room being: \u201CTrusting the output \u2014 I second-guess everything\u201D. Both speakers addressed this directly, emphasising that investors should not wait for AI to become \u201Cperfect\u201D before adopting it.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h4",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Key Segments Discussed: "
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "AI in Deal Sourcing"
	                ),
	                "- Tasks that once took hours of manual effort can now run end-to-end in the background."
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Early Stage / Consumer: Instagram trend-tracking, Amazon & quick commerce scraping, and LinkedIn outreach can now be automated end-to-end \u2014 from spotting a category trend to reaching the founder building in it."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Growth Stage: Relationships still drive growth-stage deal flow. AI strengthens them \u2014 mapping warm intro paths across the whole team\u2019s network and flagging coverage gaps before opportunities go cold."
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Data & Knowledge System"
	                ),
	                "- Strong data infrastructure and organised workflows are foundational for meaningful AI adoption."
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Build a Knowledge Brain: A central repository of expert calls, meeting notes, and thesis evolution democratises institutional knowledge \u2014 giving every team member a partner\u2019s depth of context in any conversation."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Data Infrastructure First: A deal CRM is non-negotiable before any AI implementation. Centralise pitch decks, MIS, and founder notes in one place \u2014 tools like Granola can then auto-populate it from meeting notes, removing the manual burden entirely."
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h4",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Key Takeaways"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "AI adoption in investing is already happening across sourcing, research, and workflows."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Relationship-building remains human, while technology strengthens efficiency and intelligence."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Strong data infrastructure and knowledge systems are foundational for meaningful adoption."
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h4",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Tools & Platforms Mentioned"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                { style: { columnCount: 3, columnGap: '20px' } },
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Happenstance"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Harmonic AI"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "TagHash (Deal CRM)"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "LinkedIn Automation"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Amazon & Quick Commerce Platforms"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Instagram Trend Tracking"
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "AI is unlikely to replace investors, but investors who learn to work effectively with AI may significantly outperform those who don\u2019t."
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { "class": "row" },
	              _react2.default.createElement(
	                "div",
	                { "class": "col-md-12" },
	                _react2.default.createElement(
	                  "h2",
	                  { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                  "Speakers"
	                ),
	                "          ",
	                _react2.default.createElement("div", { "class": "r_btm" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "Our_Speakers container" },
	                  _react2.default.createElement(
	                    "center",
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      { className: "Speakers_img", style: { width: '60%' } },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        this.Speaker1.map(function (item, i) {
	                          if (i <= 12) {
	                            return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-6 col-sm-12 col-lg-6",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          } else return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "main_speaker_card col-md-6 col-sm-12 col-lg-6",
	                              key: i
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "Scardd" },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "s_img",
	                                  onClick: function onClick() {
	                                    return _this3.togglePopUp(item);
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "center",
	                                  null,
	                                  "  ",
	                                  _react2.default.createElement("img", {
	                                    src: item.imgUrl,
	                                    alt: item.name,
	                                    className: "img-responsive",
	                                    style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement("br", null),
	                              "    ",
	                              _react2.default.createElement("div", {
	                                className: "Speakers_name",
	                                dangerouslySetInnerHTML: { __html: item.name }
	                              }),
	                              _react2.default.createElement("div", {
	                                className: "Speakers_post",
	                                dangerouslySetInnerHTML: { __html: item.post }
	                              })
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "row" },
	              _react2.default.createElement(
	                "div",
	                { "class": "col-md-12" },
	                _react2.default.createElement(
	                  "h2",
	                  { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                  "Moderator"
	                ),
	                "          ",
	                _react2.default.createElement("div", { "class": "r_btm" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "Our_Speakers container" },
	                  _react2.default.createElement(
	                    "center",
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      { className: "Speakers_img", style: { width: '50%' } },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        this.Speaker2.map(function (item, i) {
	                          if (i <= 12) {
	                            return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-12 col-sm-12 col-lg-12",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          } else return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "main_speaker_card col-md-6 col-sm-12 col-lg-6",
	                              key: i
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "Scardd" },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "s_img",
	                                  onClick: function onClick() {
	                                    return _this3.togglePopUp(item);
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "center",
	                                  null,
	                                  "  ",
	                                  _react2.default.createElement("img", {
	                                    src: item.imgUrl,
	                                    alt: item.name,
	                                    className: "img-responsive",
	                                    style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement("br", null),
	                              "    ",
	                              _react2.default.createElement("div", {
	                                className: "Speakers_name",
	                                dangerouslySetInnerHTML: { __html: item.name }
	                              }),
	                              _react2.default.createElement("div", {
	                                className: "Speakers_post",
	                                dangerouslySetInnerHTML: { __html: item.post }
	                              })
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-ignite-session-16-may-2026-index-js-6ffbb65e8c0f3292702a.js